// const API_VERSION = "1.0.0";
export const SITE_NAME = "Huril Studio";
export const CURRENCY = "৳";
// export const ROOT_URL = "http://localhost:8099";
export const ROOT_URL = "https://api.personal.urelaa.com";
export const IMAGE_URL = `${ROOT_URL}/files`;
export const FILE_URL = `${ROOT_URL}/files`;

const API_URL = `${ROOT_URL}`;

export const UPLOAD_IMAGE_URL = `${API_URL}/upload-image`;

// auth
export const LOGIN_URL = `${API_URL}/login`;
export const REFRESH_TOKEN = `${API_URL}/login/refresh-token`;

// user
export const GET_ALL_USER = `${API_URL}/users`;
export const GET_USER_PROFILE = `${API_URL}/profile`;
export const GET_USER_BY_ID = `${API_URL}/users/id`;
export const CREATE_USER_URL = `${API_URL}/users/create`;
export const UPDATE_USER_URL = `${API_URL}/users/update`;
export const CHANGE_PASSWORD_URL = `${API_URL}/users/change-user-password`;
export const DELETE_USER_URL = `${API_URL}/users/delete`;
export const UPLOAD_PROFILE_IMAGE = `${API_URL}/upload/profile-image`;

// static page
export const GET_ALL_STATIC_PAGES = `${API_URL}/static-page`;
export const GET_STATIC_PAGE_BY_ID = `${API_URL}/static-page/id`;
export const CREATE_STATIC_PAGE_URL = `${API_URL}/static-page/create`;
export const UPDATE_STATIC_PAGE_URL = `${API_URL}/static-page/update`;
export const DELETE_STATIC_PAGE_URL = `${API_URL}/static-page/delete`;
export const UPLOAD_STATIC_PAGE_IMAGE_URL = `${API_URL}/upload-image`;

// site config
export const GET_ALL_SITE_CONFIGS = `${API_URL}/site-config`;
export const GET_SITE_CONFIG_BY_ID = `${API_URL}/site-config/id`;
export const CREATE_SITE_CONFIG_URL = `${API_URL}/site-config/create`;
export const UPDATE_SITE_CONFIG_URL = `${API_URL}/site-config/update`;
export const DELETE_SITE_CONFIG_URL = `${API_URL}/site-config/delete`;
export const UPLOAD_SITE_CONFIG_LOGO_URL = `${API_URL}/upload-image`;

// banner
export const GET_ALL_BANNERS = `${API_URL}/banners`;
export const GET_BANNER_BY_ID = `${API_URL}/banners/id`;
export const CREATE_BANNER_URL = `${API_URL}/banners/create`;
export const UPDATE_BANNER_URL = `${API_URL}/banners/update`;
export const DELETE_BANNER_URL = `${API_URL}/banners/delete`;

// whyChooseUs
export const GET_ALL_WHYCHOOSEUS = `${API_URL}/whyChooseUs`;
export const GET_WHYCHOOSEUS_BY_ID = `${API_URL}/whyChooseUs/id`;
export const CREATE_WHYCHOOSEUS_URL = `${API_URL}/whyChooseUs/create`;
export const UPDATE_WHYCHOOSEUS_URL = `${API_URL}/whyChooseUs/update`;
export const DELETE_WHYCHOOSEUS_URL = `${API_URL}/whyChooseUs/delete`;

// services
export const GET_ALL_SERVICES = `${API_URL}/services`;
export const GET_SERVICES_BY_ID = `${API_URL}/services/id`;
export const CREATE_SERVICES_URL = `${API_URL}/services/create`;
export const UPDATE_SERVICES_URL = `${API_URL}/services/update`;
export const DELETE_SERVICES_URL = `${API_URL}/services/delete`;

// pricing
export const GET_ALL_PRICING = `${API_URL}/pricing`;
export const GET_PRICING_BY_ID = `${API_URL}/pricing/id`;
export const CREATE_PRICING_URL = `${API_URL}/pricing/create`;
export const UPDATE_PRICING_URL = `${API_URL}/pricing/update`;
export const DELETE_PRICING_URL = `${API_URL}/pricing/delete`;

// instructors
export const GET_ALL_INSTRUCTORS = `${API_URL}/instructors`;
export const GET_INSTRUCTORS_BY_ID = `${API_URL}/instructors/id`;
export const CREATE_INSTRUCTORS_URL = `${API_URL}/instructors/create`;
export const UPDATE_INSTRUCTORS_URL = `${API_URL}/instructors/update`;
export const DELETE_INSTRUCTORS_URL = `${API_URL}/instructors/delete`;

// contact
export const GET_ALL_CONTACT = `${API_URL}/contact-message`;
export const GET_CONTACT_BY_ID = `${API_URL}/contact-message/id`;
export const CREATE_CONTACT_URL = `${API_URL}/contact-message/create`;
export const UPDATE_CONTACT_URL = `${API_URL}/contact-message/update`;
export const DELETE_CONTACT_URL = `${API_URL}/contact-message/delete`;

// about
export const GET_ALL_ABOUT = `${API_URL}/about`;
export const GET_ABOUT_BY_ID = `${API_URL}/about/id`;
export const CREATE_ABOUT_URL = `${API_URL}/about/create`;
export const UPDATE_ABOUT_URL = `${API_URL}/about/update`;
export const DELETE_ABOUT_URL = `${API_URL}/about/delete`;
// expenseHead

export const GET_ALL_EXPENSEHEAD = `${API_URL}/expenseHead`;
export const GET_EXPENSEHEAD_BY_ID = `${API_URL}/expenseHead/id`;
export const CREATE_EXPENSEHEAD_URL = `${API_URL}/expenseHead/create`;
export const UPDATE_EXPENSEHEAD_URL = `${API_URL}/expenseHead/update`;
export const DELETE_EXPENSEHEAD_URL = `${API_URL}/expenseHead/delete`;
// incomeHead

export const GET_ALL_INCOMEHEAD = `${API_URL}/incomeHead`;
export const GET_INCOMEHEAD_BY_ID = `${API_URL}/incomeHead/id`;
export const CREATE_INCOMEHEAD_URL = `${API_URL}/incomeHead/create`;
export const UPDATE_INCOMEHEAD_URL = `${API_URL}/incomeHead/update`;
export const DELETE_INCOMEHEAD_URL = `${API_URL}/incomeHead/delete`;
// expense

export const GET_ALL_EXPENSE = `${API_URL}/expense`;
export const GET_EXPENSE_BY_ID = `${API_URL}/expense/id`;
export const CREATE_EXPENSE_URL = `${API_URL}/expense/create`;
export const UPDATE_EXPENSE_URL = `${API_URL}/expense/update`;
export const DELETE_EXPENSE_URL = `${API_URL}/expense/delete`;
// income

export const GET_ALL_INCOME = `${API_URL}/income`;
export const GET_INCOME_BY_ID = `${API_URL}/income/id`;
export const CREATE_INCOME_URL = `${API_URL}/income/create`;
export const UPDATE_INCOME_URL = `${API_URL}/income/update`;
export const DELETE_INCOME_URL = `${API_URL}/income/delete`;
// group

export const GET_ALL_GROUP = `${API_URL}/group`;
export const GET_GROUP_BY_ID = `${API_URL}/group/id`;
export const CREATE_GROUP_URL = `${API_URL}/group/create`;
export const UPDATE_GROUP_URL = `${API_URL}/group/update`;
export const DELETE_GROUP_URL = `${API_URL}/group/delete`;
// CONSTANT_EXPORTS_AREA
export const ACCESS_TOKEN = "huril-studio-token";
export const PROFILE = "huril-studio-profile";
export const ORDER_STATE_COLOR = {
    INITIATED: "",
    SUPPLIER_ACCEPTED: "cyan",
    DELIVERY_MAN_PICKED: "blue",
    COMPLETED: "green",
    CANCELED: "red"
};
export const GENDER_COLOR = {
    MALE: "blue",
    FEMALE: "green",
    OTHERS: "purple"
};
export const COMPANY = {
    name: "URELAA",
    address: "Dhaka Division, Bangladesh"
};
export const BACK_BUTTON_COLOR = "#3390FF";
// end
